__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = undefined;
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ey-xd/motif-react", "6.11.1450370", () => (() => (__webpack_require__(/*! ../node_modules/@ey/motif-react-wrapper/lib/motif-react.cjs */ "../node_modules/@ey/motif-react-wrapper/lib/motif-react.cjs"))), 1);
			register("@ey/icons", "1.0.886519", () => (() => (__webpack_require__(/*! ../node_modules/@ey/icons/index.js */ "../node_modules/@ey/icons/index.js"))), 1);
			register("@ey/styled-theme", "1.0.763627", () => (() => (__webpack_require__(/*! ../node_modules/@ey/icons/node_modules/@ey/styled-theme/index.js */ "../node_modules/@ey/icons/node_modules/@ey/styled-theme/index.js"))), 1);
			register("@ey/styled-theme", "2.16.1466298", () => (() => (__webpack_require__(/*! ../node_modules/@ey/canvascoreservices-teams/node_modules/@ey/styled-theme/index.js */ "../node_modules/@ey/canvascoreservices-teams/node_modules/@ey/styled-theme/index.js"))), 1);
			register("@ey/styled-theme", "2.16.1471174", () => (() => (__webpack_require__(/*! ../node_modules/@ey/styled-theme/index.js */ "../node_modules/@ey/styled-theme/index.js"))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(/*! ../node_modules/react-dom/index.js */ "../node_modules/react-dom/index.js"))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(/*! ../node_modules/@ey/icons/node_modules/react/index.js */ "../node_modules/@ey/icons/node_modules/react/index.js"))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(/*! ../node_modules/react/index.js */ "../node_modules/react/index.js"))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};